import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FormField } from "@/components/FormBits";
import { useAuth } from "@/context/AuthContext";
import { api, formatError } from "@/lib/api";

const EMPTY = { current: "", next: "", confirm: "" };

export default function AdminAccount() {
  const { user } = useAuth();
  const [f, setF] = useState(EMPTY);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.next !== f.confirm) return setError("A confirmação não confere com a nova senha");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Senha alterada com sucesso");
      setF(EMPTY);
    } catch (err) {
      setError(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-xl space-y-6">
      <div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">Minha conta</h1>
        <p className="text-slate-500">Acesso do administrador: <span className="font-semibold text-slate-700" data-testid="admin-account-email">{user?.email}</span></p>
      </div>
      <form onSubmit={submit} className="space-y-4 rounded-md border border-slate-200 bg-white p-6" data-testid="change-password-form">
        <h2 className="flex items-center gap-2 font-display text-lg font-bold"><KeyRound className="h-5 w-5 text-[#0099DD]" /> Trocar senha</h2>
        <FormField id="current-password" label="Senha atual" type="password" required value={f.current} onChange={set("current")} />
        <FormField id="new-password" label="Nova senha (mín. 8 caracteres)" type="password" minLength={8} required value={f.next} onChange={set("next")} />
        <FormField id="confirm-password" label="Confirme a nova senha" type="password" minLength={8} required value={f.confirm} onChange={set("confirm")} />
        {error && <p className="rounded-md bg-red-50 p-3 text-sm text-red-700" data-testid="change-password-error">{error}</p>}
        <Button type="submit" disabled={busy} className="bg-[#0099DD] hover:bg-sky-700" data-testid="btn-change-password">{busy ? "Salvando..." : "Salvar nova senha"}</Button>
      </form>
    </div>
  );
}
